import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

export interface ConfigState {
  forceUpdate: IForceUpdate
  softUpdate: IForceUpdate
  inMaintenance: boolean
  allowedCompanyId: string[]
}

export interface IForceUpdate {
  version: string
  isForceUpdate: boolean
}

const initialState = {
  inMaintenance: false,
  forceUpdate: {
    version: '1.0.0',
    isForceUpdate: false,
  },
  softUpdate: {
    version: '1.0.0',
    isForceUpdate: false,
  },
  allowedCompanyId: [],
} as ConfigState

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    updateConfig: (state, { payload }: PayloadAction<ConfigState>) => {
      state.inMaintenance = payload.inMaintenance
      state.forceUpdate = payload.forceUpdate
      state.softUpdate = payload.softUpdate
      state.allowedCompanyId = payload.allowedCompanyId
    },
  },
})

export const { updateConfig } = configSlice.actions

export default configSlice.reducer
